<script setup lang="ts">
import type {ChartData} from '@/client/mentor/MessagesClient'
import {ChartType} from '@/client/mentor/MessagesClient'
import AssistantMessageBarChart from '@/components/assistant/chat/message/AssistantMessageBarChart.vue'
import AssistantMessageLineChart from '@/components/assistant/chat/message/AssistantMessageLineChart.vue'
import AssistantMessagePieChart from '@/components/assistant/chat/message/AssistantMessagePieChart.vue'

defineProps<{
  chartData: ChartData
}>()
</script>

<template>
  <AssistantMessageBarChart v-if="chartData.type === ChartType.BAR" :chart-data="chartData" />
  <AssistantMessageLineChart v-else-if="chartData.type === ChartType.LINE" :chart-data="chartData" />
  <AssistantMessagePieChart v-else-if="chartData.type === ChartType.PIE" :chart-data="chartData" />
</template>
